import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'

// Translation provided by Vuetify (typescript)
import en from 'vuetify/src/locale/en.ts'
import it from 'vuetify/src/locale/it.ts'

//import { preset } from 'vue-cli-plugin-vuetify-preset-reply/preset'

Vue.use(Vuetify);

const options = {
  icons: {
    iconfont: 'mdi',
    values: {},
  },
  lang: {
    current: 'en',
    locales: { en, it }
  },
  theme: {
    themes: {
      light: {
        primary: '#126184',
        secondary: '#fccb3d',
        tertiary: '#ee4726'
      },
    },
  },
  pagination: {
    rowsPerPageItems:[
      5,
      15,
      25,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
  }
}

export default new Vuetify(options)
